import React from 'react';
import { Skeleton } from '@cp/ds/src/components/skeleton';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { SearchIcon } from '@cp/ds/src/icons/search';
import { ClientType } from '@common/model/client/clientType';
import { Link, LinkProps } from '@cp/ds/src/components/link';
import { useClientProfile } from 'src/entities/client';
import { useNavigateToCatalog } from '../model';

export const NavigateToCatalogLink: React.FC<LinkProps> = ({ sx, ...props }) => {
  const clientProfile = useClientProfile();
  const { isLoading, navigateToCatalog } = useNavigateToCatalog();

  if (!clientProfile) {
    return null;
  }

  const isSpecialist = clientProfile.type === ClientType.Specialist;

  return (
    <Stack direction="row" sx={sx}>
      {isLoading ? (
        <Skeleton width={120} />
      ) : (
        <Link onClick={() => navigateToCatalog()} sx={{ display: 'flex' }} underline={false} {...props}>
          <SearchIcon />
          <Typography sx={{ ml: 0.75 }} variant="body bold">
            {isSpecialist ? 'Поиск работы' : 'Поиск помощника'}
          </Typography>
        </Link>
      )}
    </Stack>
  );
};

export default NavigateToCatalogLink;
